export { EggCounter } from './egg-counter';
